import { IFloatSelectSerialItem } from '../../../FloatSelectSerial';
import { formatShortDate } from 'utils/formatDatesAndHours';
import { NudosSelectButton } from 'components/NudosComponents';

export const BulkSerialItem = ({
  index,
  item,
  isSelected,
  toggleSerialSelection,
  selectedSerials,
  unselectedSerialsList,
  isUnselectedSerialsList,
  requiredUnits
}: {
  index: number;
  item: IFloatSelectSerialItem;
  isSelected: boolean;
  toggleSerialSelection: (item: IFloatSelectSerialItem, isSelected: boolean) => void;
  selectedSerials: IFloatSelectSerialItem[];
  unselectedSerialsList?: IFloatSelectSerialItem[];
  isUnselectedSerialsList: boolean;
  requiredUnits: number;
}) => {
  const isNotLastSelectedSerial = index !== selectedSerials?.length - 1;
  const isNotLastUnselectedSerial = index !== (unselectedSerialsList?.length ?? 0) - 1;
  const renderShowDivider = isUnselectedSerialsList ? isNotLastUnselectedSerial : isNotLastSelectedSerial;

  return (
    <div className="serialItemContainer">
      <div className="serialItemContent">
        <div className="checkboxContainer">
          <NudosSelectButton
            iconName={isSelected ? 'checkmark' : ''}
            isButtonActive={isSelected}
            handleClickButton={() => toggleSerialSelection(item, isSelected)}
            componentSize="small w-3 h-3"
          />
          <div className="serialAndProviderContainer">
            <div className="serial">Serial: {item.serial}</div>
            <div className="providerName">Proveedor: {item.providerName}</div>
          </div>
        </div>
        <div className="billingNumberContainer">
          <div className="billingNumber">Factura: {item.billingNumber}</div>
        </div>
        <div className="dateContainer">
          {item.isFirtsOut && <div className="firstOut">(Primero por salir)</div>}
          <div className="date">Fecha: {formatShortDate(item.date)?.onlyDate ?? ''}</div>
        </div>
      </div>
      {renderShowDivider && <div className="divider isItemList" />}
    </div>
  );
};

export default BulkSerialItem;
